import { VStack } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import { FileUploadContextDirect } from '@duke-hq/svc-files-ui/FileUploadContextDirect';
import { FileUploadDropzone } from '@duke-hq/svc-files-ui/FileUploadDropzone';
import { FileUploadList } from '@duke-hq/svc-files-ui/FileUploadList';
import { FileUploadTrigger } from '@duke-hq/svc-files-ui/FileUploadTrigger';
import { ACCEPTABLE_FILES } from '@duke-hq/svc-files-lib/schemas';

export function FileUploadDemo() {
  return (
    <VStack my={8} alignItems="center">
      <FileUploadContextDirect
        quantity={{ min: 1, max: 10 }}
        accept={ACCEPTABLE_FILES}
        attachedToId="demo-id"
        attachedToKind="demo"
      >
        <FileUploadList />
        <FileUploadDropzone />
        <FileUploadTrigger>
          <Button>Select Files</Button>
        </FileUploadTrigger>
      </FileUploadContextDirect>
    </VStack>
  );
}
